import debounce from 'lodash/debounce';
import history from '../router/history';

export default debounce((queryFields, name, value) => {
  history.replace({ query: { ...queryFields, [name]: value } });
}, 300);
